// extracted by mini-css-extract-plugin
export default {"wrapper":"eu-z","response":"fu-z","error":"gu-z","disabled":"hu-z","buttons":"iu-z","feedbackQuestionSection":"ju-z","yesNoWrapper":"ku-z"};